// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/comparison/comparison.component.scss
// module id = 167
// module chunks = 0